import { History } from "lucide-react";
import { useMicrocopy } from "../lib/microcopy";

/** The line shown above a field whose unsaved text `useDraft` brought back, with the way to drop it. */
export function DraftRestoredNote({ onDiscard }: { onDiscard: () => void }) {
  const m = useMicrocopy();
  return (
    <p role="status" className="mb-2 flex items-center gap-2 rounded-lg border border-seablue-200 bg-seablue-50 px-3 py-1.5 text-xs text-seablue-900">
      <History className="size-3.5 shrink-0" aria-hidden />
      <span className="flex-1">{m("draftRestored")}</span>
      <button type="button" onClick={onDiscard} className="font-medium underline-offset-2 hover:underline">{m("draftDiscard")}</button>
    </p>
  );
}
